/**
 * @file text-warnings.ts
 * @description Предупреждения о текстах блока (phase19.16 Р2; контракт
 * §16.6): сервер находит основу слова («лечи»), а человеку показываем
 * слово целиком, как он его написал («лечит»).
 */

import type { SiteTextWarning } from "../api-site-pages";

const LETTER = "[\\p{L}\\p{N}]";
const escapeRegExp = (v: string) => v.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** Целое слово текста, в котором найдена основа; не нашлось — сама основа. */
export function wholeWord(text: string, term: string): string {
  if (!term) return term;
  const re = new RegExp(`${LETTER}*${escapeRegExp(term)}${LETTER}*`, "iu");
  return re.exec(text)?.[0] ?? term;
}

/** Текст предупреждения со словом целиком: «лечи» → «лечит». */
export function warningMessage(w: SiteTextWarning): string {
  const word = wholeWord(w.text, w.term);
  if (word === w.term) return w.message;
  return w.message.split(`«${w.term}»`).join(`«${word}»`);
}
